// @flow

export class ThreeDSecureError extends Error {}
